<template lang="html">
  <div class="gallary" v-if="show">
    <!-- TODO: add a scoped slot to add more control -->
    <div class="gallary__toolbar">
      <span @click="onClose" class="cursor gallary-close"><i class='fas fa fa-times'></i></span>
      <slot name="toolbar" :selected="selected">
      </slot>
    </div>
    <!-- <span class="close cursor" @click="show=false;">&times;</span> -->

    <!-- large image display gallary -->
    <div class="gallary__content" v-click-outside="onClose">
      <div class="mySlides">
        <div class="numbertext">{{ activeImageNumber }}/{{ totalImages }}</div>
        <img :src="activeImage" style="width:100%">
      </div>

      <a v-if="!isFirstImage" class="prev" @click="changeActive(-1)">&#10094;</a>
      <a v-if="!isLastImage" class="next" @click="changeActive(+1)">&#10095;</a>

      <div class="previous__area" @click="changeActive(-1)">
      </div>
      <div class="next__area" @click="changeActive(+1)">
      </div>

      <!-- adds space between the big image and the thumbnails -->
      <div class="caption-container">
        <p id="caption"></p>
      </div>

      <!-- small list of images inside the gallary -->
      <div class="gallary__thumbnails">
        <img v-for="(image, i) in images" width="25%" height="90px" class="demo cursor" :src="image" style="" @click="selected=i">
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { identifyFileType, FILE_TYPES } from '@/utils/file_type';
import audioThumbnail from 'icons/audio-thumbnail.png';
import videoThumbnail from 'icons/video-thumbnail.png';
import documentThumbnail from 'icons/document-thumbnail.png';

export default {
  props: {
    // images: {
    //   type: Array,
    //   required: true,
    //   default: () => [],
    // },
    // show: {
    //   type: Boolean,
    //   requried: true,
    // },
    // active: {
    //   description: 'index of the active image, if not provided first image will be shown',
    //   type: Number,
    //   default: 0,
    // },
  },
  data() {
    return {
      selected: 0,
    };
  },
  computed: {
    ...mapGetters({
      show: 'gallery/show',
      active: 'gallery/active',
      // images: 'gallery/images',
    }),
    images() {
      const images = this.$store.getters['gallery/images'];
      for (let i = 0; i < images.length; i += 1) {
        images[i] = this.createThumbnailUrl(images[i]);
      }
      return images;
    },
    totalImages() {
      return this.images.length;
    },
    activeImage() {
      return this.images[this.selected];
    },
    activeImageNumber() {
      return this.selected + 1;
    },
    isFirstImage() {
      return this.selected === 0;
    },
    isLastImage() {
      return this.selected >= this.totalImages - 1;
    },
  },
  methods: {
    createThumbnailUrl(url) {
      /* eslint global-require: "warn" */
      const fileType = identifyFileType(url);
      switch (fileType) {
        case FILE_TYPES.IMAGE:
          return url;
        case FILE_TYPES.VIDEO:
          return videoThumbnail;
        case FILE_TYPES.AUDIO:
          return audioThumbnail;
        default:
          return documentThumbnail;
      }
    },
    onClose() {
      this.$emit('close');
      this.$store.dispatch('gallery/hideGallery');
    },
    changeActive(inc) {
      let tempActive = this.selected;
      tempActive += inc;
      if (tempActive < 0) tempActive = 0;
      if (tempActive >= this.totalImages) tempActive = this.totalImages - 1;

      this.selected = tempActive;
    },
  },
  watch: {
    active(val) {
      this.selected = val;
    },
  },
  mounted() {
    this.selected = this.active;
    window.addEventListener('keyup', (e) => {
      const code = e.code;
      // do the tricks only if the popup is active
      if (this.show) {
        if (code === 'ArrowLeft') this.changeActive(-1);
        if (code === 'ArrowRight') this.changeActive(1);
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.column {
  float: left;
  width: 25%;
}

/* The Modal (background) */
.gallary {
  position: fixed;
  z-index: 4;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: black;
}

.gallary__toolbar {
  position: fixed;
  top: 0;
  right: 0;
  padding: 15px;
  margin: 0;
  width: 100%;
  min-height: 55px;
  /* background: rgba(255, 255, 255, 0.15); */
}

/* Modal Content */
.gallary__content {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  width: 90%;
  max-width: 1200px;
}

/* The Close Button */
.gallary-close {
  color: white;
  opacity: 0.8;
  float: right;
  font-size: 25px;
  margin-right: 25px;
}

.gallary-close:hover,
.gallary-close:focus {
  opacity: 0.7
}

.mySlides {
  background: black;
  /* display: none; */
  img {
   margin-bottom: -8px;
   height: 50%;
  }
}

.cursor {
  cursor: pointer
}


.previous__area {
  cursor: pointer;
  position: absolute;
  height: calc(100% - 210px);
  width: 50%;
  top: 0;
}

.next__area {
  cursor: pointer;
  position: absolute;
  height: calc(100% - 210px);
  width: 50%;
  top: 0;
  right: 0;
}

/* Next & previous__areaous buttons */
.prev,
.next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  padding: 16px;
  margin-top: -85px;
  color: white;
  font-weight: bold;
  font-size: 20px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  user-select: none;
  -webkit-user-select: none;
}

/* Position the "next button" to the right */
.next {
  right: 0;
  border-radius: 3px 0 0 3px;
}

/* On hover, add a black background color with a little bit see-through */
.prev:hover,
.next:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

/* Number text (1/3 etc) */
.numbertext {
  color: #f2f2f2;
  font-size: 12px;
  padding: 8px 12px;
  position: absolute;
  top: 0;
}

.caption-container {
  text-align: center;
  background-color: black;
  padding: 2px 16px;
  color: white;
}

.demo {
  opacity: 0.6;
}

.active,
.demo:hover {
  opacity: 1;
}

img.hover-shadow {
  transition: 0.3s
}

.hover-shadow:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}

.gallary__thumbnails {
  background: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue